var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5801 27.1812H0.617188V2.36833C0.617188 1.05664 1.67383 0 2.98552 0H16.2117C17.5234 0 18.5801 1.05664 18.5801 2.36833V27.1812ZM2.2568 25.5415H16.9405V2.36833C16.9405 1.96754 16.6125 1.63961 16.2117 1.63961H2.98552C2.58472 1.63961 2.2568 1.96754 2.2568 2.36833V25.5415Z",
    fill: "#7BB053"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3737 14.246H3.78711V3.27881H15.3737V14.246ZM5.42672 12.6064H13.7705V4.95486H5.42672V12.6064Z",
    fill: "#7BB053"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9331 27.1815C20.6579 27.1815 19.6012 26.1249 19.6012 24.8496V16.9066H17.7794C17.3422 16.9066 16.9414 16.5422 16.9414 16.0686C16.9414 15.5949 17.3058 15.2305 17.7794 15.2305H21.2408V24.8132C21.2408 25.1775 21.5323 25.5055 21.9331 25.5055C22.3339 25.5055 22.6254 25.214 22.6254 24.8132V8.78138C22.6254 8.34415 22.9898 7.94336 23.4634 7.94336C23.9371 7.94336 24.3015 8.30772 24.3015 8.78138V24.8132C24.2286 26.1613 23.2084 27.1815 21.9331 27.1815Z",
    fill: "#7BB053"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4256 9.58244C23.1342 9.58244 22.8427 9.40026 22.6969 9.10877L19.3813 2.36813C19.1991 1.96734 19.3448 1.45724 19.7456 1.27506C20.1464 1.09288 20.6565 1.23862 20.8387 1.63942L24.1544 8.38005C24.3365 8.78085 24.1908 9.29095 23.79 9.47313C23.6807 9.546 23.5349 9.58244 23.4256 9.58244Z",
    fill: "#7BB053"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.131 4.11743C21.131 4.11743 20.1108 6.23071 20.2201 6.99587C20.3294 7.76102 20.8395 10.5301 23.135 8.23468L21.131 4.11743Z",
    fill: "#7BB053"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.c91e3fd861fe5cb633e4439115eb585f.svg";
export { ForwardRef as ReactComponent };